import { LikeToneRequest } from './liketonerequest';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { GET } from '../../api';

export class LikeToneAPI extends SixdeeCRBTAPI<LikeToneRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/like-unlike
        return "like-unlike";
    }

    getRequestData()
    {
        return "aPartyMsisdn="+ this.getRequest().getLikeToneRequest().getAPartyMsisdn()+"&"+
               "likeToneId="+ this.getRequest().getLikeToneRequest().getLikeToneId()+"&"+
               "unlikeToneId="+ this.getRequest().getLikeToneRequest().getUnlikeToneId();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/liketune/liketoneapi.tsx